
const delayFadeIn = document.querySelectorAll('.delay-fadein');

delayFadeIn.forEach(element => {
  // 获取数据属性
  const dataset = element.dataset;
  let {
    parent,
    el,
    scrub,
    reverse,
    duration,
    actions,
    fn
  } = dataset;

  // 获取父元素
  let parentEl = parent ? document.querySelector(parent) : element;

  // 获取需要动画的元素
  let delayEl = [];
  if (el) {
    el.split(',').forEach(selector => {
      delayEl.push(...parentEl.querySelectorAll(selector));
    });
  } else {
    delayEl = [...parentEl.children];
  }

  // 设置默认值
  let toggleActions = "play none none none";
  scrub = scrub ? true : false;
  duration = duration || 0.8;
  const start = dataset.start || 80;
  const stagger = dataset.delay || 0.3;

  // 设置初始状态
  gsap.set(delayEl, {
    opacity: 0,
    y: 30
  });

  // 创建时间轴
  let tl = gsap.timeline();
  tl.to(delayEl, {
    stagger,
    opacity: 1,
    y: 0,
    duration
  });

  // 如果有自定义函数
  if (fn && typeof k1c_tl[fn] === 'function') {
    console.log(fn);
    tl = k1c_tl[fn](tl);
  }

  // 处理反向动画
  if (reverse) {
    toggleActions = "play none none reverse";
    gsap.set(element, {
      opacity: 0,
      y: 30
    });

    let t2 = gsap.to(element, {
      opacity: 1,
      y: 0,
      duration
    });

    ScrollTrigger.create({
      animation: t2,
      toggleActions,
      trigger: element,
      scrub,
      start: `top ${start}%`,
    });
  }

  // 设置自定义动作
  if (actions) {
    toggleActions = actions;
  }

  // 创建滚动触发器
  ScrollTrigger.create({
    animation: tl,
    toggleActions,
    trigger: element,
    scrub,
    start: `top ${start}%`,
    // markers: true
    // once: true
  });
});
// 获取所有带有 fadein class 的元素
const fadeInElements = document.querySelectorAll('.fadein');

// 为每个元素设置初始状态和动画
fadeInElements.forEach(element => {
  const delay = element.dataset.delay || 0;
  // 设置初始状态
  gsap.set(element, {
    opacity: 0,
    y: 30  // 初始位置向下偏移30px
  });

  // 创建滚动触发的动画
  ScrollTrigger.create({
    trigger: element,
    start: "top 80%", // 当元素顶部到达视窗80%位置时触发
    animation: gsap.to(element, {
      duration: 0.8,
      opacity: 1,
      y: 0,
      ease: "power2.out",
      delay
    }),
    toggleActions: "play none none none"
  });
});